import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";
import { STATS } from "../config/site";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setN(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} data-testid="stat-counter">
      {n}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section
      className="relative border-y border-white/[0.06] bg-[#07080f] py-20"
      data-testid="stats-section"
    >
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[280px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-600/[0.09] blur-[110px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-6xl grid-cols-2 gap-x-6 gap-y-12 px-5 sm:px-8 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={0.08 * i}>
            <div className="text-center" data-testid={`stat-item-${i + 1}`}>
              <p className="text-gradient font-display text-5xl font-extrabold tracking-tight sm:text-6xl">
                <Counter value={s.value} suffix={s.suffix} />
              </p>
              <p className="mx-auto mt-3 flex items-center justify-center gap-3 text-sm font-medium text-slate-400">
                <span className="hidden h-px w-6 bg-gradient-to-r from-transparent to-indigo-400/60 sm:block" />
                {s.label}
                <span className="hidden h-px w-6 bg-gradient-to-l from-transparent to-indigo-400/60 sm:block" />
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
